import React, { useState, useEffect } from "react";
import Header from "../Common/Header";
import Sidebar from "../Common/Sidebar";
import Footer from "../Common/Footer";
import axios from "axios";
import Swal from "sweetalert2";


export default function AdminPurchase() {
    const [packages, setPackages] = useState([]);
    const [txUserId, setTxUserId] = useState("");
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [loading, setLoading] = useState(false);

    // Fetch packages
    const getPackages = async () => {
        try {
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "package",
                submethod: "get",
                key: process.env.REACT_APP_KEY,
            });

            if (res.data?.resCode === 200) {
                setPackages(res.data.data || []);
            }
        } catch (err) {
            console.error("Package fetch error", err);
        }
    };

    useEffect(() => {
        getPackages();
    }, []);

    const payableAmount = selectedPackage
        ? selectedPackage.amount * quantity
        : 0;

    const handlePurchase = async () => {
        if (!selectedPackage) {
            Swal.fire("Error", "Select a package first", "error");
            return;
        }
        if (quantity <= 0) {
            Swal.fire("Error", "Enter a valid quantity", "error");
            return;
        }
        if (!txUserId || !selectedPackage) {
            Swal.fire("Error", "Enter User ID & select package", "error");
            return;
        }

        try {
            setLoading(true);

            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "transaction",
                submethod: "insert",
                key: process.env.REACT_APP_KEY,
                username: txUserId,
                amount: selectedPackage.amount,
                value: quantity,
            });

            // console.log('selectedPackage.value', selectedPackage.value);
            
            // console.log('res.data', res.data);
            
            if (res.data?.resCode === 200) {
                Swal.fire("Success", "Package Purchased Successfully", "success");
                setTxUserId("");
                setSelectedPackage(null);
                setQuantity(1);
            } else {
                Swal.fire("Error", res.data?.error || "Failed", "error");
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            Swal.fire("Error", "Server Error", "error");
        }
    };

    return (
        <>
            <Header />
            <Sidebar />

            

            <div className="buy-package-container">
                <h2 className="buy-title">Buy Package</h2>

                <div className="input-group">
                    <input
                        type="text"
                        placeholder="Enter User ID"
                        value={txUserId}
                        onChange={(e) => setTxUserId(e.target.value)}
                    />
                </div>

                <div className="package-grid">
                    {packages.map((pkg) => (
                        <div
                            key={pkg.value}
                            className={`package-card ${selectedPackage?.value === pkg.value ? "active" : ""
                                }`}
                            onClick={() => setSelectedPackage(pkg)}
                        >
                            <h4>{pkg.p_name}</h4>
                            <span className="price">${pkg.amount}</span>
                        </div>
                    ))}
                </div>

                <div className="bottom-section">
                    <div className="quantity-group">
                        <label>Quantity</label>
                        <input
                            type="number"
                            min="1"
                            value={quantity}
                            onChange={(e) => setQuantity(Number(e.target.value))}
                            style={{
                                width: "80px",
                                borderRadius: "5px",
                                padding: "5px",
                            }}
                        />
                    </div>

                    <div className="payable-amount">
                        Payable Amount
                        <strong>${payableAmount}</strong>
                    </div>
                </div>


                <button
                    className="buy-btn"
                    onClick={handlePurchase}
                    disabled={loading}
                >
                    {loading ? "Processing..." : "Confirm Purchase"}
                </button>

            </div>

            <style>
                {`
     .buy-package-container {
    max-width: 1000px;
    margin: 80px auto 40px; /* 👈 top right/left bottom */
    padding: 35px;
    border-radius: 20px;
    background: #ffffff;
    box-shadow: 0 10px 35px rgba(0, 0, 0, 0.08);
    text-align: center;
}


.buy-title {
    font-size: 26px;
    font-weight: 700;
    color: #1e88ff;
    margin-bottom: 30px;
}

.input-group input {
    width: 260px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid #dcdcdc;
    outline: none;
    font-size: 15px;
}

.package-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 22px;
    margin: 35px 0;
}

.package-card {
    padding: 22px;
    border-radius: 16px;
    background: linear-gradient(135deg, #b7d0e4ff, #4a97eeff);
    color: #ffffff;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 8px 20px rgba(33, 150, 243, 0.25);
}

.package-card h4 {
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 600;
}

.package-card .price {
    font-size: 15px;
    opacity: 0.9;
}

.package-card:hover {
    transform: translateY(-6px) scale(1.02);
}

.package-card.active {
    outline: 4px solid #0d47a1;
}

.bottom-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 30px 0;
    flex-wrap: wrap;
    gap: 20px;
}

.quantity-group label {
    margin-right: 10px;
    font-weight: 600;
    color: #333;
}

.quantity-group input {
    width: 90px;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid #ccc;
    text-align: center;
}

.payable-amount {
    font-size: 17px;
    color: #333;
}

.payable-amount strong {
    display: block;
    font-size: 22px;
    color: #1e87fff6;
    margin-top: 4px;
}

.buy-btn {
    margin-top: 20px;
    padding: 12px 55px;
    border-radius: 14px;
    border: none;
    background: linear-gradient(135deg, #1e88ff, #1565c0);
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 8px 25px rgba(30, 136, 255, 0.35);
    transition: all 0.3s ease;
}

.buy-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(30, 136, 255, 0.45);
}

.buy-btn:disabled {
    background: #b0cfff;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
    opacity: 0.8;
}


.loader-overlay {
    position: fixed;
    inset: 0;
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: 600;
    z-index: 9999;
}

    `}
            </style>
            <Footer />
        </>
    );
}
